import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddCounselor from "./AddCounselor";

const AddCounselorLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Add Counselor" />
      <AddCounselor />
    </MasterLayout>
  );
};

export default AddCounselorLayout;
